import { copy } from "./shared";
import CheckoutForm from "./CheckoutForm";
import "../templates/Template5.css";
import "./CheckoutTemplate5.css";

export default function CheckoutTemplate5({ data = {}, code }) {
  const c = copy(data);
  return (
    <div className="clp5-root">
      {/* ══ NAVBAR ══ */}
      <nav className="nav-w">
        <div className="container">
          <div className="d-flex align-items-center justify-content-between">
            <span className="brand">
              {c.logo ? <img src={c.logo} className="site-logo" alt="Logo" /> : <span className="cok5-brandtext">{c.brand}</span>}
            </span>
            <span className="cok5-secure">🔒 Secure checkout</span>
          </div>
        </div>
      </nav>

      {/* ══ HERO ══ */}
      <section className="hero cok5-hero">
        <div className="hero-noise" />
        <div className="hero-lime-line" />
        <div className="hero-glow" />
        <div className="container">
          <div className="cok5-hero-content">
            <span className="cok5-eyebrow">Checkout</span>
            <h1 className="hero-title">Complete your <span className="li">enrollment</span></h1>
            {c.sub ? <p className="hero-sub cok5-hero-sub">{c.sub}</p> : null}
          </div>
        </div>
      </section>

      {/* ══ FORM + SUMMARY ══ */}
      <div className="container">
        <CheckoutForm data={data} code={code} p="cok5" c={c} />
      </div>

      {/* ══ FOOTER ══ */}
      <footer className="foot">
        <div className="container">
          <div className="cok5-foot">{c.guaranteeOn ? c.guarantee : "© " + c.brand}</div>
        </div>
      </footer>
    </div>
  );
}
